<template>
  <div
    v-if="!isFocused"
    class="overflow-hidden truncate placeholder-container admin-field-single-select"
    @click="isFocused = true"
  >
    <template v-if="!isFocused">
      <AdminCellEmptyPlaceholder v-if="isEmpty" />
      <slot
        name="invalid"
        v-else-if="!isSelectionInOptions"
        :the-selection="theSelection"
      >
        <div class="font-italic grey--text text--darken-1 selection-title">{{
          theSelection
        }}</div>
      </slot>
      <slot v-else :the-selection="theSelection">
        <v-chip
          v-if="chips"
          :key="theSelection"
          color="grey lighten-2"
          small
          class="proxima--font mr-1"
        >
          {{ theSelection }}
        </v-chip>
        <div class="selection-title" v-else>{{ theSelection }}</div>
      </slot>
    </template>
  </div>
  <v-select
    v-else
    v-model="theSelection"
    dense
    hide-details
    :items="items"
    :no-data-text="noDataText"
    class="single-select mt-0"
    v-on="$listeners"
    autofocus
    @blur="isFocused = false"
  />
</template>

<script>
import AdminCellEmptyPlaceholder from '@/components/AdminCellEmptyPlaceholder'
import _includes from 'lodash/includes'
export default {
  name: 'AdminInputSingleSelect',
  components: { AdminCellEmptyPlaceholder },
  props: {
    items: {
      type: Array,
      require: true,
      default: () => [],
    },
    value: {
      type: [String, Number],
      default: () => [],
    },
    chips: {
      type: Boolean,
      default: true,
    },
    noDataText: {
      type: String,
      default: 'No selections found.',
    },
  },
  computed: {
    isEmpty() {
      return !this.theSelection
    }, // isEmpty
    isSelectionInOptions() {
      return _includes(this.items, this.theSelection)
    }, // isSelectionInOptions
  },
  data() {
    return {
      theSelection: this.value,
      isFocused: false,
    }
  },
  watch: {
    isFocused(isFocused) {
      this.$emit('focus:change', isFocused)
    },
    value(v) {
      this.theSelection = v
    },
  },
}
</script>

<style>
.selection-title {
  cursor: pointer;
}
.single-select.v-text-field > .v-input__control > .v-input__slot:before {
  display: none;
}
</style>
